import React, { useEffect } from 'react'
import Admin from './components/Admin'
import Home from './components/Home'
import "leaflet/dist/leaflet.css";  
import { Route, Routes } from 'react-router-dom'
import RegisterAsDoctor from './components/auth/registerAsDoctor/RegisterAsDoctor'
import DoctorHome from './components/doctor_dashboard/DoctorHome'
import DoctorPatients from './components/doctor_dashboard/DoctorPatients'
import DoctorChatPage from './components/doctor_dashboard/DoctorChatPage'
import DoctorSettingsPage from './components/doctor_dashboard/DoctorSettings'
import DoctorEarningsPage from './components/doctor_dashboard/DoctorEarning'
import DoctorAvailabilityPage from './components/doctor_dashboard/DoctorAvailability'
import Login from './components/auth/Login'
import Paystack from './components/Paystack'
import PaymentFailed from './components/PaymentFailed'
import AboutUs from './components/AboutUs'
import ContactUs from './components/ContactUs'
import NotFound from './components/NotFound'
import DoctorVerification from './components/doctor_dashboard/DoctorVerification'
import AdminPatientsPage from './components/admin/AdminPatients'
import AdminChatPage from './components/admin/AdminChat'
import ReviewPage from './components/Review'
import AdminReviews from './components/admin/AdminReview'
import RegisterPharmacy from './components/doctor_dashboard/RegisterAPharmacy'
import PharmacyDashboard from './components/doctor_dashboard/PharmacyDashboard'
import PharmaciesPage from './components/doctor_dashboard/Pharmacies'
import CostingPage from './components/doctor_dashboard/PharmacyCostingPage'
import MedicationPaymentCallback from './components/doctor_dashboard/MedicationPayment'
import AdminRequests from './components/doctor_dashboard/AdminRequests'
import ReferralDecisionPage from './components/doctor_dashboard/ReferralDicisionPage'
import AdminReferralsPage from './components/doctor_dashboard/AdminReferrals'
import CallEntryPage from './components/CallEntryPage'
import ConsultationPaymentCallback from './components/doctor_dashboard/ConsultationCallback'
import AdminClientPortalContent from './components/admin/AdminClientPortalContent'
import AdminDoctorsPage from './components/admin/AdminDoctors'
import AdminDashboard from './components/admin/AdminDashboard'
import PebblesAdmin from './components/admin/PebblesAdmin'
import AdminRemindersPage from './components/admin/AdminEmails'
import AdminHomeTests from './components/admin/AdminHomeTests'

const Main = () => {

  console.log('token', localStorage.getItem('token'))
  // self.addEventListener("push", (event) => {
  //   const data = event.data?.json();
  
  //   self.registration.showNotification(data.title, {
  //     body: data.body,
  //     icon: "/icon-192.png",
  //   });
  // });

  useEffect(() => {
    if (!("Notification" in window)) return;
  
    if (Notification.permission === "default") {
      Notification.requestPermission().then((perm) => {
        console.log("Permission set to:", perm);
      });
    }
  }, []);


  useEffect(() => {
    const loader = document.getElementById("loader");
    if (loader) loader.remove();
  }, []);



  return (
    <Routes>
    <Route path="*" element={<NotFound />} />
    <Route path="/" element={<Home />} />
    <Route path="/about" element={<AboutUs />} />
    <Route path="/contact" element={<ContactUs />} />
    <Route path="/register-as-doctor" element={<RegisterAsDoctor />} />



    <Route path="/login" element={<Login />} />

    <Route path="/dashboard/home" element={<DoctorHome />} />
    <Route path="/dashboard/verification" element={<DoctorVerification />} />
    <Route path="/dashboard/patients" element={<DoctorPatients />} />
    <Route path="/dashboard/availability" element={<DoctorAvailabilityPage />} />
    <Route path="/dashboard/reminders" element={<AdminRemindersPage />} />
    <Route path="/dashboard/settings" element={<DoctorSettingsPage />} />
    <Route path="/dashboard/earning" element={<DoctorEarningsPage />} />

    {/* pharmacy */}
    <Route path="/register-a-pharmacy" element={<RegisterPharmacy />} />
    <Route path="/dashboard/pharmacy/:pharmId" element={<PharmacyDashboard />} />
    <Route path="/admin/pharmacies" element={<PharmaciesPage />} />

   
    <Route path="/dashboard/patient/:client_id" element={<DoctorChatPage />} />


    <Route path="/admin/requests" element={<AdminRequests />} />

    <Route path="/admin" element={<Admin />} />
    {/* <Route path="/admin/email-marketing" element={<EmailMarketingPage />} />

    <Route path="/admin/email-marketing-main" element={<EmailMarketingMain />} /> */}


 <Route path="/referrals/:id" element={<ReferralDecisionPage />} />
 <Route path="/call/:shortId" element={<CallEntryPage />} />
 <Route path="/cost-medication/:requestId" element={<CostingPage />} />
    <Route path="/medication-payment/callback" element={<MedicationPaymentCallback />} />
    <Route path="/pay-per-consultation/callback" element={<ConsultationPaymentCallback />} />
    <Route path="/review/:patientId" element={<ReviewPage />} />

    <Route path="/vp" element={<Paystack />} />
    <Route path="/payment-failed/:clientId" element={<PaymentFailed />} />

    {/* admin Routes */}
    <Route path="/admin/dashboard" element={<AdminDashboard />} />
    <Route path="/admin/pebbles" element={<PebblesAdmin />} />
    <Route path="/admin/patients" element={<AdminPatientsPage />} />
    <Route path="/admin/doctors" element={<AdminDoctorsPage />} />
    <Route path="/admin/home-tests" element={<AdminHomeTests />} />
    <Route path="/admin/reminders" element={<AdminRemindersPage adminMode />} />
    <Route path="/admin/emails" element={<AdminRemindersPage adminMode />} />
    <Route path="/admin/reviews/" element={<AdminReviews />} />
    <Route path="/admin/chat/:client_id" element={<AdminChatPage />} />
    <Route path="/admin/referrals" element={<AdminReferralsPage />} />
    <Route path="/admin/client-content" element={<AdminClientPortalContent />} />
   


  </Routes>
  )
}

export default Main
